<script>
  import { getContext } from "svelte";
  import { Tabs, Tab, TabList, TabPanel } from "svelte-tabs";
  import { countryStore } from "../store/Countries.js";
  import CustomSelectBox from "../SharedComponents/CustomSelectBox.svelte";
  const { close } = getContext("modal");
  const { snackbar } = getContext("app");
  export let setVar;
  let activeVariable;
  export let VariableList = [];

  export let filterText = "";
  let filteredVariables;

  $: filteredVariables = filterText
    ? $countryStore.currentCountryVersion.variables
        .filter(
          (v) => !VariableList.some((vv) => vv.varNameKey == v.varNameKey)
        )
        .filter((v) =>
          (v.varNameKey + "").toLowerCase().includes(filterText.toLowerCase())
        )
        .sort(sortbyName)
    : $countryStore.currentCountryVersion.variables
        .filter(
          (v) => !VariableList.some((vv) => vv.varNameKey == v.varNameKey)
        )
        .sort(sortbyName);

  function sortbyName(a, b) {
    if (a.varNameKey > b.varNameKey) return 1;
    if (a.varNameKey < b.varNameKey) return -1;
    return 0;
  }
  function setActiveVariable(variable) {
    activeVariable == variable
      ? (activeVariable = null)
      : (activeVariable = variable);
  }

  function linkVariable(theVar) {
    setVar(theVar);
    VariableList.push(theVar);
    snackbar("success", "variabele " + theVar.name + " gekoppeld");
    //close();
  }

  function editVariable(theVar) {
    setVar(theVar);

    snackbar("success", "variabele " + theVar.name + " aangepast");
    close();
  }
  function init(element) {
    element.focus();
  }
</script>

<div class="modal-body" style="height:570px">
  <Tabs>
    <TabList>
      <Tab>Choos a variable</Tab>
    </TabList>
    <TabPanel>
      <input
        type="text"
        class="form-control p-4 mb-4"
        bind:value={filterText}
        id="variabele"
        autocomplete="off"
        placeholder="Zoek een variabele"
        required=""
        use:init
      />
      <ul class="list-group fold-out" style="height:400px;overflow-y:auto;">
        {#if filteredVariables}
          {#each filteredVariables as variable}
            <li
              class="list-group-item"
              on:click={() => setActiveVariable(variable)}
            >
              <span style="float:right">
                <em>{variable.dataType}</em>
              </span>
              <h6>{variable.varNameKey}</h6>
              {#if activeVariable == variable}
                <div class="list-group-item-details pt-3">
                  {#if variable.formula}
                    <p class="font-italic">{variable.formula}</p>
                  {/if}
                  <p class="text-center mt-4">
                    <button
                      type="button"
                      class="btn btn-primary"
                      on:click={linkVariable(variable)}
                    >
                      Variabele koppelen
                    </button>
                  </p>
                </div>
              {/if}
            </li>
          {/each}
        {/if}
      </ul>
    </TabPanel>
  </Tabs>
</div>
